import React from 'react';
import { Stack, Box } from '@mantine/core';
import { ContextMessage } from '@/client/features/signals/types';
import { MessageItem } from '@/client/features/signals/components/MessageItem';

type Props = {
  list: ContextMessage[];
  sides: ('left' | 'right')[];
  isDark: boolean;
  collector: string;
};

export const MessageList = React.memo(({ list, sides, isDark, collector }: Props) => (
  <Stack gap="lg" style={{ overflow: 'visible' }}>
    {list.map((m, i) => (
      <React.Fragment key={`${m.author}-${m.date}-${m.current_message}-${m.content.length}`}>
        <MessageItem message={m} side={sides[i]} isDark={isDark} collector={collector} />
        {i < list.length - 1 && (
          <Box
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: isDark ? 'rgba(255, 255, 255, 0.25)' : 'var(--quo-grey-15)',
              margin: '8px 0',
            }}
          />
        )}
      </React.Fragment>
    ))}
  </Stack>
));
